<footer class="footer">
  <div class="footer__content">
    <a href="external/about" class="footer__content-item">Read more about the Coach Index</a>
    <a href="external/faq" class="footer__content-item">Frequently Asked Questions</a>
    <a href="external/privacy-policy" class="footer__content-item">Coach Index Privacy Policy</a>
  </div>
  <div class="footer__extra">
    <img class="footer__extra-image" src="/assets/images/banner-footer-image.png">
  </div>
</footer>